export default "__VITE_ASSET__DUpFg2hw__"